import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { ModalFooter } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SeasonalRuleAddEditModalFooter = ({
  closeModal,
}: {
  closeModal: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <ModalFooter>
      <ModalFormCancelButton
        data-testid="seasonal-rule-cancel-button"
        closeOnClick={false}
        onClick={closeModal}
      />
      <ModalFormSubmitButton data-testid="seasonal-rule-submit-button">
        {t('pageProperty.seasonality.modal.buttons.save')}
      </ModalFormSubmitButton>
    </ModalFooter>
  );
};

export default SeasonalRuleAddEditModalFooter;
